'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosPartlysunny = function IoIosPartlysunny(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.3 11.7v-4.2h1.2v4.2h-1.2z m-11.3 8.3v-1.2h4.3v1.2h-4.3z m3.4-8.4l0.8-0.8 2.5 2.5-0.8 0.8z m14 2.5l-0.8-0.9 2.5-2.5 0.8 0.9z m-13 13.4l-0.8-0.9 2.4-2.4 0.9 0.9z m14-10c2.8 0 5.3 2 5.9 4.8h0.6c2.8 0 5.1 2.2 5.1 5s-2.3 5.2-5.1 5.2h-12.2c-2.2 0-4.1-1.9-4.1-4.1 0-2.1 1.6-4 3.7-4.2v-0.6c0-3.4 2.7-6.1 6.1-6.1z m-2.7-2.2l0.1 0.2c-2.4 0.4-4.9 3.3-4.9 5.8 0 0.2 0.1 0.4 0.1 0.6l-0.1 0.1h0c-0.9 0.4-1.4 1-1.8 2-1.8-1-3-2.8-3-4.9 0-3.1 2.5-5.6 5.5-5.6 1.7 0 3.1 0.7 4.1 1.8z' })
        )
    );
};

exports.default = IoIosPartlysunny;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-partlysunny.js
// module id = 2259
// module chunks = 0